var _circle, _line, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdultMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.471 319.492C209.731 319.492 215.603 327.622 215.603 343.883V429.252C215.603 445.964 216.507 461.322 221.024 471.259H259.869C255.352 460.87 254.448 445.061 254.448 428.8V343.431C254.448 325.364 247.221 310.458 229.154 302.779C245.415 297.359 254.448 284.26 254.448 267.096V197.536C254.448 166.369 235.478 146.947 203.408 146.947H143.333V471.259H182.178V319.492H193.471ZM215.603 201.149V266.192C215.603 279.291 209.731 286.067 198.891 286.067H182.178V181.275H198.891C209.731 181.275 215.603 188.05 215.603 201.149Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.729 471.259V145.14H312.176C306.304 174.5 292.754 179.468 265.201 180.372V209.731H300.884V471.259H339.729Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.556 302.779C371.489 310.458 362.455 325.364 362.455 343.431V424.283C362.455 455.45 385.943 474.872 417.561 474.872C449.179 474.872 472.667 455.45 472.667 424.283V343.431C472.667 325.364 463.633 310.458 445.565 302.779C463.633 295.1 470.86 280.195 470.86 262.127V193.922C470.86 162.756 449.179 143.333 417.561 143.333C385.943 143.333 364.261 162.756 364.261 193.922V262.127C364.261 280.195 371.489 295.1 389.556 302.779ZM433.37 200.246V263.934C433.37 277.033 428.401 285.615 417.561 285.615C406.72 285.615 401.752 277.033 401.752 263.934V200.246C401.752 187.147 406.72 178.565 417.561 178.565C428.401 178.565 433.37 187.147 433.37 200.246ZM433.821 417.96C433.821 431.059 428.401 439.641 417.561 439.641C406.72 439.641 401.3 431.059 401.3 417.96V342.076C401.3 328.977 406.72 320.395 417.561 320.395C428.401 320.395 433.821 328.977 433.821 342.076V417.96Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(108 108)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultMaterial);
export default __webpack_public_path__ + "static/media/adult-material.e6ee52f3f57329e3fe2104f29333fe3a.svg";
export { ForwardRef as ReactComponent };